var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{fill-rule:evenodd;}.b{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22,6V18H2V6ZM5.071,8H3.5l2.009,8H6.883l.855-4.678.25-1.547.25,1.547L9.093,16h1.413L12.5,8H11l-.947,4.63-.216,1.227-.216-1.275L8.776,8H7.214l-.8,4.608L6.21,13.856l-.2-1.275ZM17.051,8a3.346,3.346,0,0,0-2.445.944A4.125,4.125,0,0,0,13.5,12.029a4.155,4.155,0,0,0,.972,2.914A3.445,3.445,0,0,0,17.141,16a3.256,3.256,0,0,0,2.251-.783,3.4,3.4,0,0,0,1.092-2.032H18.855a2.357,2.357,0,0,1-.416.887,1.612,1.612,0,0,1-1.319.55,1.75,1.75,0,0,1-1.391-.64,2.9,2.9,0,0,1-.547-1.926,3.3,3.3,0,0,1,.518-1.988,1.664,1.664,0,0,1,1.415-.7,1.7,1.7,0,0,1,1.33.5,2.132,2.132,0,0,1,.411.83H20.5a2.69,2.69,0,0,0-.545-1.426A3.347,3.347,0,0,0,17.051,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.7f25174ab8f8674f4aeaee52020a0f80.svg";
export { ForwardRef as ReactComponent };